import { PROCESS_STEPS } from "../../data/content";

export const Process = () => (
  <section id="prozess" className="py-24 md:py-32 px-6 md:px-12 bg-[#171B21] border-y border-[#2A303A]" data-testid="process-section">
    <div className="max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-[1fr_1.3fr] gap-14 lg:gap-24 items-start">
        <div className="lg:sticky lg:top-28">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#2E5BFF] mb-4">So arbeiten wir</p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">
            Vier Schritte. Kein Blindflug.
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#9AA3AF] leading-relaxed max-w-md">
            Sie wissen zu jedem Zeitpunkt, was passiert, was es kostet und wann es fertig ist.
          </p>
        </div>
        <div className="space-y-6 lg:space-y-24 lg:pb-24">
          {PROCESS_STEPS.map((s, i) => (
            <div
              key={s.num}
              className="stack-card bg-[#101318] border border-[#2A303A] p-8 md:p-10"
              style={{ top: `${96 + i * 20}px`, zIndex: i + 1 }}
              data-testid={`process-step-${s.num}`}
            >
              <div className="flex items-start gap-6">
                <span className="font-display text-3xl md:text-4xl font-bold text-[#2E5BFF] leading-none">{s.num}</span>
                <div>
                  <h3 className="font-display text-xl md:text-2xl font-semibold">{s.title}</h3>
                  <p className="mt-3 text-sm md:text-base text-[#9AA3AF] leading-relaxed">{s.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
